import styleInject from '../../../common/temp/pnpm_store/.pnpm/style-inject@0.3.0/pnpm_store/style-inject/dist/style-inject.es.js';

var css_248z = ".spin_wrapper__3qVO7 {\n  text-align: center;\n  width: 100%;\n}\n.spin_wrapper__3qVO7 label {\n  margin-top: 4px;\n  display: inline-block;\n}\n";
var styles = {"wrapper":"spin_wrapper__3qVO7"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=spin.less.js.map
